const carouselItems = [
  {
    title: '日漫经典重温计划',
    desc: '那些年我们追过的经典日漫！从《龙珠》到《海贼王》，下拉式全集一次看个够。重温热血青春，感受永恒的漫画魅力。',
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20Japanese%20manga%20collection%20display%20with%20classic%20shonen%20manga%20volumes%2C%20warm%20vintage%20lighting%2C%20wooden%20bookshelf%2C%20orange%20and%20cream%20tones%2C%20editorial%20photography%2C%20clean%20aesthetic&width=1000&height=600&seq=carousel-manga-01&orientation=landscape',
    tag: '经典回顾',
    accent: 'primary' as const,
  },
  {
    title: '韩漫全彩精选专题',
    desc: '高人气韩漫全彩下拉式合集！精致的全彩画风配合流畅的下拉式阅读，每一格都是视觉享受。恋爱、奇幻、悬疑全收录。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20full%20color%20Korean%20webtoon%20display%20on%20a%20large%20tablet%20screen%2C%20vibrant%20art%20style%2C%20warm%20indoor%20lighting%2C%20cozy%20reading%20corner%2C%20modern%20aesthetic%2C%20orange%20and%20cream%20tones&width=1000&height=600&seq=carousel-manga-02&orientation=landscape',
    tag: '韩漫精选',
    accent: 'accent' as const,
  },
  {
    title: '每周新番追踪指南',
    desc: '想追最新连载但不知道看什么？每周精选热门新番推荐，下拉式追更不迷路。日漫新番、韩漫新作一网打尽。',
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20new%20manga%20releases%20with%20fresh%20covers%20arranged%20on%20a%20desk%2C%20warm%20morning%20sunlight%2C%20modern%20workspace%2C%20orange%20and%20cream%20color%20palette%2C%20editorial%20style&width=1000&height=600&seq=carousel-manga-03&orientation=landscape',
    tag: '新番追踪',
    accent: 'secondary' as const,
  },
  {
    title: '完结神作补番清单',
    desc: '那些评分超高的完结漫画神作！完整下拉式全集已整理好，不用等更新，一口气看到大结局。补番必备书单。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautifully%20organized%20shelf%20of%20completed%20manga%20series%20with%20golden%20accents%2C%20warm%20library%20lighting%2C%20sophisticated%20atmosphere%2C%20orange%20and%20cream%20tones%2C%20professional%20photography&width=1000&height=600&seq=carousel-manga-04&orientation=landscape',
    tag: '完结神作',
    accent: 'primary' as const,
  },
  {
    title: '小众宝藏漫画发掘',
    desc: '不想看千篇一律的热门作品？挖掘那些冷门但精彩的小众漫画，独特画风、新奇剧情，下拉式阅读发现惊喜。',
    image: 'https://readdy.ai/api/search-image?query=A%20curated%20display%20of%20unique%20indie%20style%20manga%20books%20with%20artistic%20covers%2C%20warm%20ambient%20lighting%2C%20creative%20atmosphere%2C%20orange%20and%20cream%20tones%2C%20editorial%20photography&width=1000&height=600&seq=carousel-manga-05&orientation=landscape',
    tag: '小众宝藏',
    accent: 'accent' as const,
  },
];

const accentBorderClasses = {
  primary: 'border-l-primary-500',
  accent: 'border-l-accent-500',
  secondary: 'border-l-secondary-500',
};

const accentTagClasses = {
  primary: 'bg-primary-50 text-primary-700',
  accent: 'bg-accent-50 text-accent-700',
  secondary: 'bg-secondary-50 text-secondary-700',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            精心策划的漫画专题合集，发现更多值得一看的下拉式漫画
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className={`group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 border-l-[3px] ${accentBorderClasses[item.accent]} transition-all duration-300 hover:border-l-primary-500 cursor-pointer`}
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium mb-3 ${accentTagClasses[item.accent]}`}>
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}